// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"f162b01f","613":"927f53b6"}[chunkId] + ".1793851335692.chunk.css";
};